import click from '../../assets/audio/click.opus';
import confirmMove from '../../assets/audio/confirm-move.opus';
import confirmWallet from '../../assets/audio/confirm-wallet.opus';
import draw from '../../assets/audio/draw.opus';
import gameBackground from '../../assets/audio/game-background.opus';
import gameStart from '../../assets/audio/game-start.opus';
import lobbyBackground from '../../assets/audio/lobby-background.opus';
import matchDefeat from '../../assets/audio/match-defeat.opus';
import matchWin from '../../assets/audio/match-win.opus';
import money from '../../assets/audio/money.opus';
import roundLoss from '../../assets/audio/round-loss.opus';
import roundWin from '../../assets/audio/round-win.opus';

export enum AUDIO_TYPES {
  CLICK = 'click',
  GAME_START = 'game-start',
  CONFIRM_WALLET = 'confirm-wallet',
  CONFIRM_MOVE = 'confirm-move',
  DRAW = 'draw',
  MATCH_DEFEAT = 'match-defeat',
  MATCH_WIN = 'match-win',
  ROUND_LOSS = 'round-loss',
  ROUND_WIN = 'round-win',
  GAME_BACKGROUND = 'game-background',
  LOBBY_BACKGROUND = 'lobby-background',
  MONEY = 'money',
}

export const soundMap = {
  [AUDIO_TYPES.CLICK]: click,
  [AUDIO_TYPES.GAME_START]: gameStart,
  [AUDIO_TYPES.CONFIRM_WALLET]: confirmWallet,
  [AUDIO_TYPES.CONFIRM_MOVE]: confirmMove,
  [AUDIO_TYPES.DRAW]: draw,
  [AUDIO_TYPES.MATCH_DEFEAT]: matchDefeat,
  [AUDIO_TYPES.MATCH_WIN]: matchWin,
  [AUDIO_TYPES.ROUND_LOSS]: roundLoss,
  [AUDIO_TYPES.ROUND_WIN]: roundWin,
  [AUDIO_TYPES.GAME_BACKGROUND]: gameBackground,
  [AUDIO_TYPES.LOBBY_BACKGROUND]: lobbyBackground,
  [AUDIO_TYPES.MONEY]: money,
};
